import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { formatCurrency } from '@/utils/common/formatting';
import { ITransactionSummary } from '@/types/admin/transactions';

interface TransactionSummaryProps {
  summary: ITransactionSummary;
}

export const TransactionSummary: React.FC<TransactionSummaryProps> = ({ summary }) => {
  const getBalanceColor = (balance: number) => {
    if (balance > 0) return ADMIN_COLORS.TRANSACTION.CHARGE; // Red for amount owed
    if (balance < 0) return ADMIN_COLORS.TRANSACTION.PAYMENT; // Green for credit
    return ADMIN_COLORS.TEXT_SECONDARY; // Gray for zero
  };

  return (
    <View style={styles.container}>
      <View style={styles.summaryCard}>
        <Text style={styles.label}>Total Charges</Text>
        <Text style={[styles.value, styles.chargeValue]}>
          {formatCurrency(summary.totalCharges)}
        </Text>
      </View>

      <View style={styles.summaryCard}>
        <Text style={styles.label}>Total Payments</Text>
        <Text style={[styles.value, styles.paymentValue]}>
          {formatCurrency(summary.totalPayments)}
        </Text>
      </View>

      <View style={styles.summaryCard}>
        <Text style={styles.label}>Current Balance</Text>
        <Text style={[styles.value, { color: getBalanceColor(summary.currentBalance) }]}>
          {formatCurrency(Math.abs(summary.currentBalance))}
          {summary.currentBalance < 0 && ' (Credit)'}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 12,
    gap: 12,
  },
  summaryCard: {
    flex: 1,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
  },
  label: {
    fontSize: 11,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT_SECONDARY,
    marginBottom: 4,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  value: {
    fontSize: 16,
    fontWeight: '700',
    color: ADMIN_COLORS.TEXT_PRIMARY,
  },
  chargeValue: {
    color: ADMIN_COLORS.TRANSACTION.CHARGE,
  },
  paymentValue: {
    color: ADMIN_COLORS.TRANSACTION.PAYMENT,
  },
});

